import React, { MouseEvent, RefObject } from "react";
import ReactDOM from "react-dom";
import cx from "classnames";
import styles from "./brandKindSelect.module.less";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import classNames from "classnames";
import { IBrandDataSource, IKindDataSource, IkindList, IModalList, IBrandSelectData } from "./types";
import throttle from "lodash/throttle";
import debounce from "lodash/debounce";
import ModelYearPopoverWrapper from "./modelYearPopover";

interface IState {
  visible: boolean;
  secondVisible: boolean;
  thirdVisible: boolean;
  value: number | string;
  label: string;
  kindValue: number | string;
  kindLabel: string;
  modalValue: number | string;
  modalLabel: string;
  posX: number;
  posY: number;
  posSecondX: number;
  posSecondY: number;
  hover: boolean;
  selLabel: string;
  fourVisible: boolean;
  modelYearValue: number | string;
  modelYearLabel: string;
}

type ICarFunction = (data: number | string, label: string) => void;

interface IProp {
  disabled?: boolean;
  size?: "small" | "middle" | "large";
  className?: string;
  ref?: any;
  selectType?: "brandKindModel" | "brandKind" | "brand";
  border?: boolean;
  onSubmit: (data: Partial<IBrandSelectData>, type: "kind" | "model" | "all" | "modelYear") => void;
  dataSource: IBrandDataSource;
  kindData: IKindDataSource;
  modelData: IModalList[];
  onBrandSelect: ICarFunction;
  onKindSelect: ICarFunction;
  field: "usedcar" | "newcar";
  selectLabel: string;
  isShowClear?: boolean;
  onClear?: () => void;
  type?: string;
  error?: boolean;
  isSelectAll: boolean;
  hideModal: boolean;
  modelYearData: IKindDataSource;
  modelYearId: string | number;
  modelYearName: string;
}

interface IKindPopover {
  value: string;
  dataSource: IKindDataSource;
  onSelect: (data: IkindList) => void;
  field: string;
  secondVisible: boolean;
  checkSecondVisible: (flag: boolean) => void;
  isSelectAll: boolean;
}

interface IModelPopover {
  value: string;
  dataSource: IModalList[];
  onSelect: (data: IModalList) => void;
  field: string;
  thirdVisible: boolean;
  checkThirdVisible: (flag: boolean) => void;
  isSelectAll: boolean;
}

interface IBrandPopover {
  dataSource: IBrandDataSource;
  modelData: IModalList[];
  value: string;
  onSelect: any;
  field: string;
  secondVisible: boolean;
  thirdVisible: boolean;
  checkVisible: () => void;
  kindData: IKindDataSource;
  isSelectAll: boolean;
  onSelectKind: (data: IkindList) => void;
  onSelectModal: (data: IModalList) => void;
  checkSecondVisible: (flag: boolean) => void;
  checkThirdVisible: (flag: boolean) => void;
  fourVisible: boolean;
  checkFourVisible: (flag: boolean) => void;
  modelYearData: IKindDataSource;
  modelYearId: string | number;
  modelYearName: string;
  onSelectModelYear: (data: any) => void;
}

function KindPopover(props: IKindPopover) {
  const { value, onSelect, dataSource, field, secondVisible, checkSecondVisible, isSelectAll } = props;
  return (
    <div
      style={{ left: secondVisible ? 0 : "235px" }}
      className={cx(styles["select-popover-list"], styles["border-radius"], styles["kind-popover"])}
    >
      <PerfectScrollbar>
        {isSelectAll && (
          <div className={styles["select-popover-section"]}>
            <span
              className={cx(styles["select-popover-section-item"], {
                [styles["select-popover-section-item-used"]]: field === "usedcar",
                [styles["active"]]: value === 0,
              })}
              onClick={() =>
                onSelect({
                  id: "",
                  enName: "",
                  image: "",
                  zhName: "",
                })
              }
            >
              全部車款
            </span>
          </div>
        )}
        {/* {dataSource.map((item) => (
          <div className={styles["select-popover-section"]} key={item.id}>
            <span
              className={cx(styles["select-popover-section-item"], {
                [styles["select-popover-section-item-used"]]: field === "usedcar",
                [styles["active"]]: value === item.id,
              })}
              onClick={() => onSelect(item)}
            >
              {item.enName}
            </span>
          </div>
        ))} */}
        {dataSource.map((item) => (
          <div
            className={cx(styles["select-popover-section"], "tc-select-section")}
            key={item.label}
            data-index={item.label}
          >
            <span className={styles["select-popover-section-header"]}>{item.label}</span>
            {item.list.map((ii) => (
              <span
                className={cx(styles["select-popover-section-item"], {
                  [styles["select-popover-section-item-used"]]: field === "usedcar",
                  [styles["active"]]: `${value}` === ii.id,
                })}
                key={ii.id}
                onClick={() => onSelect({ ...ii })}
              >
                {ii.name}
              </span>
            ))}
          </div>
        ))}
      </PerfectScrollbar>
      <div className={styles["select-popover-back"]} onClick={() => checkSecondVisible(false)}>
        返回
      </div>
    </div>
  );
}

function ModelPopover(props: IModelPopover) {
  const { value, onSelect, dataSource, field, thirdVisible, checkThirdVisible, isSelectAll } = props;
  return (
    <div
      style={{ left: thirdVisible ? 0 : "235px" }}
      className={cx(
        styles["select-popover-list"],
        styles["border-radius"],
        styles["kind-popover"],
        styles["model-popover"],
      )}
    >
      <PerfectScrollbar>
        {isSelectAll && (
          <div className={styles["select-popover-section"]}>
            <span
              className={cx(styles["select-popover-section-item"], {
                [styles["select-popover-section-item-used"]]: field === "usedcar",
                [styles["active"]]: value === 0,
              })}
              onClick={() =>
                onSelect({
                  id: "",
                  name: "",
                  enName: "",
                  zh_name: "",
                  depth: "",
                  alias: "",
                  series: "",
                  lft: "",
                  rgt: "",
                  is_double: "0",
                  isSeries: "0",
                  gas: "0",
                })
              }
            >
              全部車型
            </span>
          </div>
        )}
        {dataSource.map((item, inx) => (
          <div className={styles["select-popover-section"]} key={inx}>
            <span
              className={cx(styles["select-popover-section-item"], {
                [styles["select-popover-section-item-used"]]: field === "usedcar",
                [styles["active"]]: value === item.id,
              })}
              onClick={() => onSelect(item)}
            >
              {item.enName}
            </span>
          </div>
        ))}
      </PerfectScrollbar>
      <div className={styles["select-popover-back"]} onClick={() => checkThirdVisible(false)}>
        返回
      </div>
    </div>
  );
}

function ModelYearPopover(props: any) {
  const { value, onSelect, dataSource, field, fourVisible, checkFourVisible, isSelectAll, modelYearId, modelYearName } =
    props;

  return (
    <div
      style={{ left: fourVisible ? 0 : "235px", zIndex: 4 }}
      className={cx(
        styles["select-popover-list"],
        styles["border-radius"],
        styles["kind-popover"],
        styles["model-popover"],
      )}
    >
      <ModelYearPopoverWrapper
        initValue={{
          modelYearId,
          modelYearName,
        }}
        dataSource={dataSource}
        onSelect={onSelect}
      />
      <div className={styles["select-popover-back"]} style={{ bottom: "15px" }} onClick={() => checkFourVisible(false)}>
        返回
      </div>
    </div>
  );
}

class BrandPopover extends React.Component<IBrandPopover> {
  readonly state = {
    activeIndex: 0,
  };

  private scrollRef:
    | (HTMLElement & {
        updateScroll?: any;
      })
    | undefined;

  private updateRef: any;

  private listView: number[] = [0];

  componentDidUpdate() {
    this.renderListView();
  }

  private handleScroll = (container: any) => {
    const offsetLength = this.listView.length;
    for (let i = 0; i < offsetLength; i++) {
      const isActiveTarget =
        container.scrollTop >= this.listView[i] &&
        (typeof this.listView[i + 1] === "undefined" || container.scrollTop < this.listView[i + 1]);
      if (isActiveTarget) {
        this.setState({
          activeIndex: i,
        });
      }
    }
  };

  private renderListView = () => {
    if (this.listView.length > 1 || !this.scrollRef) {
      return;
    }
    this.updateRef.updateScroll();
    const children = Array.from(this.scrollRef.children);
    children
      .filter((ele) => ele.classList.contains("tc-select-section"))
      .forEach((item, index) => {
        this.listView.push(item.getBoundingClientRect().height + this.listView[index]);
      });
  };

  private jump = (index: number) => {
    if (this.scrollRef) {
      this.scrollRef.scrollTop = this.listView[index];
    }
  };

  render() {
    const {
      dataSource,
      value,
      onSelect,
      field,
      secondVisible,
      checkVisible,
      kindData,
      onSelectKind,
      thirdVisible,
      onSelectModal,
      checkSecondVisible,
      modelData,
      checkThirdVisible,
      isSelectAll,
      modelYearData,
      modelYearId,
      modelYearName,
      fourVisible,
      checkFourVisible,
      onSelectModelYear,
    } = this.props;
    const { activeIndex } = this.state;
    return (
      <>
        <div className={styles["select-popover-header"]}>
          <p onClick={checkVisible}>廠牌</p>{" "}
          {secondVisible && (
            <>
              <span>&gt;</span> 車款
            </>
          )}{" "}
          {thirdVisible && (
            <>
              <span>&gt;</span> 車型
            </>
          )}
          {fourVisible && (
            <>
              <span>&gt;</span> 年式車型
            </>
          )}
        </div>
        <ul className={styles["select-popover-index"]}>
          {dataSource.index.map((item, index) => (
            <li
              className={cx(styles["select-popover-index-item"], {
                [styles["select-popover-index-item-used"]]: field === "usedcar",
                [styles["active"]]: index === activeIndex,
              })}
              key={item}
              onClick={() => this.jump(index)}
            >
              {item}
            </li>
          ))}
        </ul>
        <div className={styles["select-popover-list"]}>
          <PerfectScrollbar
            ref={(ref) => (this.updateRef = ref)}
            containerRef={(ref) => {
              this.scrollRef = ref;
            }}
            onScrollY={this.handleScroll}
          >
            {dataSource.data.map((item) => (
              <div
                className={cx(styles["select-popover-section"], "tc-select-section")}
                key={item.label}
                data-index={item.label}
              >
                <span className={styles["select-popover-section-header"]}>{item.label}</span>
                {item.list.map((ii) => (
                  <span
                    className={cx(styles["select-popover-section-item"], {
                      [styles["select-popover-section-item-used"]]: field === "usedcar",
                      [styles["active"]]: `${value}` === ii.id,
                    })}
                    key={ii.id}
                    onClick={() => onSelect(ii.id, ii.enName)}
                  >
                    {ii.enName}
                  </span>
                ))}
              </div>
            ))}
          </PerfectScrollbar>
        </div>
        <KindPopover
          dataSource={kindData}
          value={value}
          onSelect={onSelectKind}
          field={field}
          secondVisible={secondVisible}
          checkSecondVisible={checkSecondVisible}
          isSelectAll={isSelectAll}
        />
        <ModelPopover
          dataSource={modelData}
          value={value}
          onSelect={onSelectModal}
          field={field}
          thirdVisible={thirdVisible}
          checkThirdVisible={checkThirdVisible}
          isSelectAll={isSelectAll}
        />
        <ModelYearPopover
          value={modelYearId}
          onSelect={onSelectModelYear}
          dataSource={modelYearData}
          field={field}
          fourVisible={fourVisible}
          checkFourVisible={checkFourVisible}
          isSelectAll={isSelectAll}
          modelYearId={modelYearId}
          modelYearName={modelYearName}
        />
      </>
    );
  }
}

class Popover extends React.Component<{
  visible: boolean;
  pos: { x: number; y: number };
  className?: any;
  type?: string;
}> {
  readonly state = {
    mounted: false,
  };

  componentDidMount() {
    this.setState({
      mounted: true,
    });
  }

  render() {
    const { children, visible, pos, className, type } = this.props;
    const { mounted } = this.state;
    const style: React.CSSProperties = { top: visible ? pos.y : -10000, left: pos.x, zIndex: 300 };

    return mounted
      ? ReactDOM.createPortal(
          <div
            className={cx(styles["select-popover"], {
              [className]: !!className,
            })}
            style={style}
          >
            {children}
          </div>,
          document.body,
        )
      : null;
  }
}

class BrandKindSelect extends React.Component<IProp, IState> {
  readonly state = {
    visible: false,
    posX: 0,
    posY: 0,
    posSecondX: 0,
    posSecondY: 0,
    secondVisible: false,
    thirdVisible: false,
    value: 0,
    label: "",
    kindValue: 0,
    kindLabel: "",
    modalValue: 0,
    modalLabel: "",
    hover: false,
    selLabel: "",
    fourVisible: false,
    modelYearValue: 0,
    modelYearLabel: "",
  };

  static defaultProps = {
    isShowClear: true,
    selectType: "brandKindModel",
  };

  private containerRef = React.createRef<HTMLDivElement>();

  private brandRef = React.createRef<HTMLDivElement>();

  private kindRef = React.createRef<HTMLDivElement>();

  componentDidMount() {
    document.addEventListener("click", this.bindEvent);
    if (document.querySelector("#car-valuation-main")) {
      (document.querySelector("#car-valuation-main") as HTMLElement).addEventListener("scroll", this.scrollCombined);
    }

    this.props.ref && this.props.ref(this);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.bindEvent);
    (document.querySelector("#car-valuation-main") as HTMLElement)?.removeEventListener("scroll", this.scrollCombined);
  }

  private bindEvent = (e: any) => {
    const target = e.target as HTMLElement;
    if (
      (this.state.visible || this.state.secondVisible) &&
      !target.className.includes("select-popover") &&
      !target.className.includes("select-value")
    ) {
      this.setState({
        visible: false,
        secondVisible: false,
      });
    }
  };

  private toggle = (e: MouseEvent, visible?: boolean) => {
    if (!!this.props.disabled) {
      return;
    }

    const target = e.target as HTMLElement;
    const rect = target.getBoundingClientRect();
    this.setState({
      posX: rect.x + window.scrollX,
      posY: rect.y + rect.height + window.scrollY,
      secondVisible: visible || false,
      visible: visible || !this.state.visible,
    });
  };

  private changePos = () => {
    if (this.state.visible && this.brandRef.current) {
      const rect = this.brandRef.current.getBoundingClientRect();
      this.setState({
        posX: rect.x + window.scrollX,
        posY: rect.y + rect.height + window.scrollY,
      });
    }
  };
  private scrollDebouncePos = debounce(this.changePos, 100);
  private scrollThrottlePos = throttle(this.changePos, 20);
  private scrollCombined = () => {
    this.scrollDebouncePos();
    this.scrollThrottlePos();
  };

  private toggleSecond = () => {
    if (this.state.value === 0 || !this.kindRef.current) {
      if (this.brandRef.current) {
        this.toggle({ target: this.brandRef.current } as any, true);
      }
      return;
    }
    const rect = this.kindRef.current.getBoundingClientRect();
    this.setState({
      posSecondX: rect.x + window.scrollX,
      posSecondY: rect.y + rect.height + window.scrollY,
      visible: false,
      secondVisible: !this.state.secondVisible,
    });
  };

  private initSecondPos = () => {
    if (this.brandRef.current) {
      const target = this.brandRef.current as HTMLElement;
      const rect = target.getBoundingClientRect();
      this.setState({
        posSecondX: rect.x + window.scrollX + 1000,
        posSecondY: rect.y + rect.height + window.scrollY,
      });
    }
  };

  private checkVisible = () => {
    this.setState({
      secondVisible: false,
      thirdVisible: false,
    });
  };

  private onSelectBrand = (value: number, label: string) => {
    this.setState(
      {
        value,
        selLabel: label,
        // kindLabel: "",
        kindValue: 0,
      },
      () => {
        if (this.props.selectType === "brand") {
          this.setState({
            visible: false,
            secondVisible: false,
            thirdVisible: false,
          });
        } else {
          this.toggleSecond();
          this.initSecondPos();
        }
      },
    );
    if (value) {
      const { field } = this.props;
      this.props.onBrandSelect(value, label);
    }
  };

  private onSelectKind = (data: IkindList) => {
    if (this.props.selectType === "brandKind" || data.id === "") {
      const { value, label } = this.state;

      this.setState({
        kindValue: data.id,
        kindLabel: data.name,
        label: this.state.selLabel,
        fourVisible: true,
      });

      this.props.onSubmit(
        {
          brandId: value,
          brandName: label,
          kindId: data.id,
          kindName: data.name,
          modelYearId: "",
          modelYearName: "",
        },
        "kind",
      );
      return;
    }

    this.setState({
      kindValue: data.id,
      kindLabel: data.name,
      thirdVisible: true,
    });
    this.props.onKindSelect(data.id, data.name);
  };

  private onSelectModal = (data: IModalList) => {
    const { value, label, kindValue, kindLabel } = this.state;

    this.setState({
      modalLabel: data.enName,
      modalValue: data.id,
      visible: false,
      secondVisible: false,
      thirdVisible: false,
    });

    this.props.onSubmit(
      {
        brandId: value,
        brandName: label,
        kindId: kindValue,
        kindName: kindLabel,
      },
      "model",
    );
  };

  private onSelectModelYear = (data: any) => {
    const { value, label, kindValue, kindLabel } = this.state;

    this.setState({
      modelYearValue: data.id,
      modelYearLabel: data.name,
      visible: false,
      secondVisible: false,
      thirdVisible: false,
      fourVisible: false,
    });

    this.props.onSubmit(
      {
        brandId: value,
        brandName: label,
        kindId: kindValue,
        kindName: kindLabel,
        modelYearId: data.id,
        modelYearName: data.name,
      },
      "modelYear",
    );
  };

  private onHover = () => {
    if (!!this.props.disabled) {
      return;
    }
    if (this.state.hover) {
      return;
    }
    this.setState({
      hover: true,
    });
  };

  private onLeave = () => {
    if (!this.state.hover) {
      return;
    }
    this.setState({
      hover: false,
    });
  };

  private onClear = () => {
    this.setState({
      value: 0,
      label: "",
      kindValue: 0,
      kindLabel: "",
      modalValue: 0,
      modalLabel: "",
    });
    this.props.onClear && this.props.onClear();
  };

  private checkSecondVisible = (flag: boolean) => {
    this.setState({ secondVisible: false });
  };

  clear = () => {
    this.setState({
      value: 0,
      label: "",
      kindValue: 0,
      kindLabel: "",
      modalValue: 0,
      modalLabel: "",
    });
    this.props.onClear && this.props.onClear();
  };

  select = ({ brandName, kindName, modelName, brandId, kindId, modelYearId, modelYearName }) => {
    this.setState({
      value: brandId,
      label: brandName,
      kindValue: kindId,
      kindLabel: kindName,
      modelYearValue: modelYearId,
      modelYearLabel: modelYearName,
    });

    this.props.onSubmit(
      {
        brandName,
        kindName,
        brandId,
        kindId,
        modelYearId,
        modelYearName,
      },
      "all",
    );
  };

  resetLayer = () => {
    this.setState({
      visible: false,
      secondVisible: false,
      thirdVisible: false,
      fourVisible: false,
    });
  }

  render() {
    const {
      visible,
      label,
      value,
      secondVisible,
      kindLabel,
      kindValue,
      posX,
      posY,
      posSecondX,
      posSecondY,
      hover,
      thirdVisible,
      modalLabel,
      modalValue,
      fourVisible,
      modelYearLabel,
      modelYearValue,
    } = this.state;
    const {
      size,
      className,
      dataSource,
      kindData,
      field,
      selectLabel,
      isShowClear,
      border,
      type,
      modelData,
      error,
      isSelectAll,
      disabled,
      hideModal,
      modelYearData,
      modelYearId,
      modelYearName,
    } = this.props;

    return (
      <>
        <div
          className={cx(styles["container"], styles[size ?? "middle"], className, {
            [styles["disabled"]]: !!disabled,
          })}
          ref={this.containerRef}
        >
          <div
            className={cx(styles["select"], "select", styles[size ?? "middle"], {
              [styles["border"]]: border,
              [styles["open"]]: visible,
              [styles["select-error"]]: error,
            })}
            onMouseEnter={() => this.onHover()}
            onMouseLeave={() => this.onLeave()}
          >
            <span
              className={cx(styles["select-value"], "select-value", {
                [styles["isSelect"]]: !!label,
              })}
              onClick={this.toggle}
              ref={this.brandRef}
            >
              {label ? `${label} ${kindLabel} ${modalLabel} ${modelYearLabel}` : selectLabel ? selectLabel : "請選擇"}
            </span>
            <svg width='10px' height='10px' viewBox='0 0 10 10' version='1.1' xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M1.94974747,1 C2.22588984,1 2.44974747,1.22385763 2.44974747,1.5 L2.44974747,7 L7.94974747,7 C8.22588984,7 8.44974747,7.22385763 8.44974747,7.5 C8.44974747,7.77614237 8.22588984,8 7.94974747,8 L1.94974747,8 C1.67360509,8 1.44974747,7.77614237 1.44974747,7.5 L1.44974747,1.5 C1.44974747,1.22385763 1.67360509,1 1.94974747,1 Z'
                fill={!!disabled ? "#e0e0e0" : "#666666"}
                mask='url(#mask-2)'
                transform='translate(4.949747, 4.500000) rotate(-45.000000) translate(-4.949747, -4.500000) '
              ></path>
            </svg>
            <Popover visible={visible} pos={{ x: posX, y: posY }} type={type}>
              <BrandPopover
                dataSource={dataSource}
                kindData={kindData}
                modelData={modelData}
                value={value}
                field={field}
                secondVisible={secondVisible}
                thirdVisible={thirdVisible}
                checkVisible={this.checkVisible}
                isSelectAll={isSelectAll}
                onSelect={this.onSelectBrand}
                onSelectKind={this.onSelectKind}
                onSelectModal={this.onSelectModal}
                onSelectModelYear={this.onSelectModelYear}
                checkSecondVisible={this.checkSecondVisible}
                checkThirdVisible={() => this.setState({ thirdVisible: false })}
                fourVisible={fourVisible}
                checkFourVisible={() => this.setState({ fourVisible: false })}
                modelYearData={modelYearData}
                modelYearId={modelYearId}
                modelYearName={modelYearName}
              />
            </Popover>
            <div
              className={styles["extra-tips"]}
              style={{ display: !visible ? "none" : "block", left: 230 + "px", top: 230 + "px" }}
            >
              <a
                href='https://www.8891.com.tw/member-suggest.html?qt_id=1'
                target='_blank'
                className={styles["question-link"]}
              >
                <img src='https://photo.8891.com.tw/2023/08/29/1693298870895568.png' alt='' />
              </a>
            </div>
            {hover && <a className={styles["clean-btn"]} onClick={this.onClear}></a>}
          </div>

          {!hideModal && (
            <div className={styles["search-container"]}>
              <span
                className={cx(styles["search-icon"], { [styles["hover"]]: hover, bounceInUp: hover, animated: hover })}
              />
            </div>
          )}
        </div>
      </>
    );
  }
}

export default BrandKindSelect;
